"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    return {
        title: 'Your new home awaits',
        connectionId: '',
        defaultValues: {},
        meta: {
            favicon: {
                hidden: false,
                name: '',
                src: '',
                file: {
                    naturalHeight: 0,
                    naturalWidth: 0,
                    size: 0,
                },
                pendingFile: undefined,
            },
            title: '',
        },
        images: {
            headerLogo: {
                hidden: false,
                name: '',
                src: '/images/logo-landing.svg',
                file: {
                    naturalHeight: 72,
                    naturalWidth: 460,
                    size: 0,
                },
                pendingFile: undefined,
            },
            bottomImage: {
                hidden: true,
                name: '',
                src: '/images/image_placeholder.svg',
                file: {
                    naturalHeight: 0,
                    naturalWidth: 0,
                    size: 0,
                },
                pendingFile: undefined,
            },
        },
        sections: {
            top: {
                hidden: false,
                styles: {
                    backgroundColor: '#85be3d',
                },
            },
            bottom: {
                hidden: false,
                styles: {
                    backgroundColor: '#FFFFFF',
                },
            },
            disclaimer: {
                hidden: false,
                styles: {
                    backgroundColor: '#FFFFFF',
                },
            },
            footer: {
                hidden: false,
                styles: {
                    backgroundColor: '#ffffff',
                },
            },
        },
        texts: {
            header: {
                hidden: false,
                content: 'Your new home awaits.',
                styles: {
                    color: '#1c2e6b',
                    fontSize: 30,
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontFamily: 'Roboto',
                    fontStyle: 'none',
                    letterSpacing: 1,
                    lineHeight: 1,
                    display: 'inline-block',
                    whiteSpace: 'pre-wrap',
                    textDecoration: 'inherit',
                },
            },
            copy: {
                hidden: false,
                content: "You've made an exciting step forward, now it's time to manage your latest investment and build a clear understanding of your financial future. We're here to help you every step of the way, beginning with a personalized video to welcome you to the Adificial family.",
                styles: {
                    color: '#2e2e2e',
                    fontSize: 22,
                    textAlign: 'center',
                    fontFamily: 'Roboto',
                    fontStyle: 'none',
                    fontWeight: 'normal',
                    letterSpacing: 1,
                    lineHeight: 1.5,
                    display: 'inline-block',
                    whiteSpace: 'pre-wrap',
                    textDecoration: 'inherit',
                },
            },
            subHeader: {
                hidden: false,
                content: 'Take a moment to learn more:',
                styles: {
                    color: '#1c2e6b',
                    fontSize: 26,
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontFamily: 'Roboto',
                    fontStyle: 'none',
                    letterSpacing: 1,
                    lineHeight: 1,
                    display: 'inline-block',
                    whiteSpace: 'pre-wrap',
                    textDecoration: 'inherit',
                },
            },
            disclaimer: {
                hidden: true,
                content: '*Disclosure text should go here, allowing for your fine print to convey the proper messaging from a compliance and legal perspective.',
                styles: {
                    color: '#000000',
                    fontSize: 10,
                    textAlign: 'center',
                    fontFamily: 'Roboto',
                    fontStyle: 'none',
                    fontWeight: 'normal',
                    letterSpacing: 0,
                    lineHeight: 1.2,
                    display: 'inline-block',
                    whiteSpace: 'pre-wrap',
                    textDecoration: 'inherit',
                },
            },
            footer: {
                hidden: false,
                content: '© Copyright 2023 Created with Adificial.',
                styles: {},
            },
        },
        buttons: {
            left: {
                hidden: false,
                label: 'Meet your Personal Advisor',
                target: '',
                styles: {
                    color: '#17171b',
                    backgroundColor: '#fcab2c',
                    borderColor: '#000000',
                    borderWidth: '0',
                    borderRadius: '8px',
                    textAlign: 'left',
                    fontFamily: 'Roboto',
                    fontStyle: 'none',
                    letterSpacing: 1,
                    lineHeight: 1,
                    textDecoration: 'none',
                    fontSize: 16,
                    fontWeight: 'bold',
                },
            },
            right: {
                hidden: false,
                label: 'Sign into My Account',
                target: '',
                styles: {
                    color: '#17171b',
                    backgroundColor: '#fcab2c',
                    borderColor: '#000000',
                    borderWidth: '0',
                    borderRadius: '8px',
                    textAlign: 'left',
                    fontFamily: 'Roboto',
                    fontStyle: 'none',
                    letterSpacing: 1,
                    lineHeight: 1,
                    textDecoration: 'none',
                    fontSize: 16,
                    fontWeight: 'bold',
                },
            },
        },
    };
}
exports.default = default_1;
